import { ReactNode } from "react";
import styled from "styled-components";
import {
  EditorPageContainer,
  EditorPagePanel,
} from "../../components/SharedStyles";

interface EditorPageProps {
  leftPanel: ReactNode;
  centerPanel: ReactNode;
  rightPanel: ReactNode;
}

const Layout = styled.div`
  display: grid;
  grid-template-columns: 300px 500px 1fr;
  height: 100%;
`;

export default function EditorPage({
  leftPanel,
  centerPanel,
  rightPanel,
}: EditorPageProps) {
  return (
    <EditorPageContainer>
      <Layout>
        <EditorPagePanel>{leftPanel}</EditorPagePanel>
        <EditorPagePanel>{centerPanel}</EditorPagePanel>
        <EditorPagePanel>{rightPanel}</EditorPagePanel>
      </Layout>
    </EditorPageContainer>
  );
}
